//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Navigation',
  props: {
    next: {
      type: Boolean,
      default: true,
    },
  },
};
